module.exports = __webpack_public_path__ + "static/media/devolu.6830d91f.png";